const registry = require('../registry');

/**
 * @type {import('../registry').ExtractAccessFunction}
 */
function extractAccess(hNode, options) {
    const { showForAction } = hNode;

    let spec = [];
    let access = {};
    // 'new' detail panes are special:
    // Specifically, we handle the permission for CREATING new records through the (+) button.
    // If they can't click that, they can't get here.
    // If they can, then they should be able to click save (or cancel)
    if (['new'].includes(showForAction)) {
        return { spec, access };
    }
    //otherwise, just process as anything else:
    return registry.hNode.extractAccess(hNode, options);
}
const detailPanes = {
    DetailPane: { extractAccess }
};
registry.register('detailPanes',  detailPanes);
module.exports = detailPanes;
